import { makeStyles, Theme } from "@material-ui/core/styles"
import WebIcon from "@material-ui/icons/Web"
import MobileIcon from "@material-ui/icons/MobileScreenShare"
import AppsIcon from "@material-ui/icons/Apps"
import Tab from "@material-ui/core/Tab"
import Tabs from "@material-ui/core/Tabs"
import React, { useState } from "react"
import SwipeViews from "react-swipeable-views"
import Calendar from "Components/Calendar"
import { CalendarTab } from "Types/app"

const tabArray: CalendarTab[] = [
    {
        value: "pc站点",
        text: "pc站点",
        icon: <WebIcon/>,
    },
    {
        value: "移动站点",
        text: "移动站点",
        icon: <MobileIcon/>,
    },
    {
        value: "果壳APP",
        text: "果壳APP",
        icon: <AppsIcon/>,
    },
]

const useStyles = makeStyles((theme: Theme) => ({
    "@global": {
        "#root": {
            display: "flex",
        },
    },
    root: {
        backgroundColor: theme.palette.background.paper,
    },
    tabIndicator: {
        height: 0,
    },
    tabItem: {
        lineHeight: 1,
        marginTop: 4,
        borderRadius: theme.shape.borderRadius,
        fontSize: 14,
        minHeight: 0,
    },
    selectedItem: {
        backgroundColor: "#ff9800",
        color: "white",
        borderWidth: 0,
    },
}))

export default function CenteredTabs() {
    const classes = useStyles()
    const [ index, setIndex ] = useState(0)

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setIndex(newValue)
    }
    const handleChangeIndex = (index: number) => {
        setIndex(index)
    }
    return (
        <div className={classes.root}>
            <Tabs
                value={index}
                onChange={handleChange}
                classes={{
                    indicator: classes.tabIndicator,
                }}
                centered
            >
                {
                    tabArray.map((tab: CalendarTab, index) => (
                        <Tab
                            label={tab.text}
                            icon={tab.icon}
                            key={tab.value}
                            value={index}
                            classes={{
                                root: classes.tabItem,
                                selected: classes.selectedItem,
                            }}
                        />
                    ))
                }
            </Tabs>
            <SwipeViews
                index={index}
                onChangeIndex={handleChangeIndex}
            >
                {
                    tabArray.map((tab: CalendarTab) => (
                        <div key={tab.value}>
                            <Calendar channelName={tab.value}/>
                        </div>
                    ))
                }
            </SwipeViews>
            <div id="board_input_modal" />
        </div>
    )
}
